import { ExternalReviewSourceType } from '../../../../../../store/api/external-reviews-api';

export type SourceType =
  | 'youtube'
  | '2gis'
  | 'instagram'
  | 'vk'
  | 'facebook'
  | 'tiktok'
  | 'googlemaps'
  | 'yandexmaps'
  | 'otzovik'
  | 'yandexmarket'
  | 'kaspi'
  | 'wildberries'
  | 'ozon'
  | 'linkedin'
  | 'unknown';

export const detectSourceType = (url: string): SourceType => {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();
    const path = urlObj.pathname.toLowerCase();

    if (hostname.includes('youtube.') || hostname === 'youtu.be') {
      return 'youtube';
    }
    if (hostname.includes('2gis.')) {
      return '2gis';
    }
    if (hostname.includes('instagram.')) {
      return 'instagram';
    }
    if (hostname.includes('vk.com') || hostname.includes('vkontakte.')) {
      return 'vk';
    }
    if (hostname.includes('facebook.') || hostname === 'fb.com' || hostname.endsWith('.fb.com')) {
      return 'facebook';
    }
    if (hostname.includes('tiktok.')) {
      return 'tiktok';
    }
    if (hostname.includes('google.') && (hostname.includes('maps') || path.includes('/maps'))) {
      return 'googlemaps';
    }
    if (hostname.includes('yandex.') && (hostname.includes('maps') || path.includes('/maps'))) {
      return 'yandexmaps';
    }
    if (hostname.includes('otzovik.')) {
      return 'otzovik';
    }
    if (hostname.includes('market.yandex.') || hostname.includes('yandex.market')) {
      return 'yandexmarket';
    }
    if (hostname.includes('kaspi.')) {
      return 'kaspi';
    }
    if (hostname.includes('wildberries.') || hostname === 'wb.ru' || hostname.endsWith('.wb.ru')) {
      return 'wildberries';
    }
    if (hostname.includes('ozon.')) {
      return 'ozon';
    }
    if (hostname.includes('linkedin.')) {
      return 'linkedin';
    }

    return 'unknown';
  } catch {
    return 'unknown';
  }
};

export const getSourceInfo = (url: string): ExternalReviewSourceType | null => {
  const sourceType = detectSourceType(url);

  if (sourceType === 'unknown') {
    return null;
  }

  const sourceNames: Record<SourceType, string> = {
    youtube: 'YouTube',
    '2gis': '2GIS',
    instagram: 'Instagram',
    vk: 'VK',
    facebook: 'Facebook',
    tiktok: 'TikTok',
    googlemaps: 'Google Maps',
    yandexmaps: 'Yandex Maps',
    otzovik: 'Otzovik',
    yandexmarket: 'Yandex Market',
    kaspi: 'Kaspi Market',
    wildberries: 'Wildberries',
    ozon: 'Ozon',
    linkedin: 'LinkedIn',
    unknown: 'Неизвестный источник',
  };

  // Иконки будут определяться на клиенте из companySocialIcons
  // В API храним только тип источника
  return {
    name: sourceNames[sourceType],
    icon: sourceType, // Храним тип источника, иконку получаем на клиенте
  };
};

export const normalizeSourceName = (name: string) =>
  name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

export const getSourceIconByName = (name: string): string => {
  const normalized = normalizeSourceName(name).replace(/\s/g, '');
  const map: Record<string, string> = {
    '2gis': '2gis',
    instagram: 'instagram',
    vk: 'vk',
    facebook: 'facebook',
    tiktok: 'tiktok',
    youtube: 'youtube',
    googlemaps: 'googlemaps',
    yandexmaps: 'yandexmaps',
    otzovik: 'otzovik',
    yandexmarket: 'yandexmarket',
    kaspimarket: 'kaspi',
    wildberries: 'wildberries',
    ozon: 'ozon',
    linkedin: 'linkedin',
  };

  return map[normalized] || 'unknown';
};

export const collectionFrequencyOptions = [
  { id: '1', value: '1 раз в сутки' },
  { id: '2', value: '2 раза в сутки' },
  { id: '3', value: '3 раза в сутки' },
];
